import { useEffect, useState } from "react";

const ReturnPolicy = () =>{

    return(<> 
    
    {/* <!-- Breadcumb Section Start --> */}
    <div className="breadcrumb-img">
		<img src="assets/img/banner/return.jpg" alt="MeriPustak-Return-Cancellation-Policy"/>
    </div>

    {/* <!-- About Section Start --> */}
    <section className="about-section fix section-padding">
        <div className="container">
            <div className="about-wrapper">
			
                <div className="row g-4 align-items-center">
                    <div className="col-lg-12">
                        <div className="about-content">
                           <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Return & Cancellation Policy:</h3>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">
                             We always strive to provide you the best online experience and services on every single purchase.</p>
							  <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Order from INDIA:</h3>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">We have a 3-day exchange/return policy, which means you have 3 days after receiving your item.</p>
							 <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">International ORDER / Order from Other countries:</h3>
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Return/Exchange Policy: Currently, we do not accept any returns or exchanges of our products for international orders, except in the case of wrong product delivery, where items differ from what was ordered."</p>
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">To request a replacement or a return. For exchange/return, you can contact us at:</p>
                        </div>
                    </div>
                </div>
				<hr/>
				<div className="row g-4 align-items-center">
                    <div className="col-lg-4">
                        <div className="about-content">
								<table border={1} style={{color: "black"}}>
									<tbody>
										<tr><td style={{padding:"10px"}}><b>Email ID</b></td><td style={{padding:"10px"}}>contactus@meripustak.com </td></tr>
										<tr><td style={{padding:"10px"}}><b>Toll Free </b></td><td style={{padding:"10px"}}>1800 891 7183  </td></tr>
										<tr><td style={{padding:"10px"}}><b>WhatsApp No.</b></td><td style={{padding:"10px"}}>+ 91 99905 33212</td></tr>
										<tr><td style={{padding:"10px"}}><b>Working Hour</b></td><td style={{padding:"10px"}}>Mon-Fri 10 AM- to 6 PM IST</td></tr>
									</tbody>
								</table>
							
                        </div>
                    </div>
					<div className="col-md-8"> 
							<table style={{color: "black"}}>
									<tbody><tr><td style={{padding:"10px"}}>&nbsp;</td></tr>
									<tr><td>&nbsp;</td></tr>
									<tr><td style={{padding:"10px"}}><p>"Response Time: Within 24 business hours."</p></td></tr>
									<tr><td style={{padding:"10px"}}>&nbsp;</td></tr>
									<tr><td style={{padding:"10px"}}>&nbsp;</td></tr>
									
								</tbody></table>
							</div>
                </div>
				<hr/>
				<div className="row g-4 align-items-center">
                    <div className="col-lg-12">
                        <div className="about-content">
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">MeriPustak will ONLY accept a return of delivered products IF:</p>
                            <p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s"><b>The product you have received is ‘Damaged’ OR ‘Defective’ OR ‘Not as described or shown in website while placing the order’.</b></p>
							  <h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Returns:</h3>
							<p className="mt-3 mb-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Kindly provide us with the following details to process the Return Request at our end.</p>
							<ol>
								<li>To initiate a return or exchange, please contact us with your Order ID details.</li>
								<li>Our Customer Support team will verify and confirm your request, and they will provide you with further instructions on the process. Alternatively, you can cancel the order yourself if it has not been dispatched yet.</li>
								<li>Please ensure that the product is in its original and unused condition, including all price tags, labels, original packaging, and the invoice. This will help facilitate the return or exchange process smoothly.</li>
							</ol>
							<h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">When Are Returns Not Possible?</h3>
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">There are certain scenarios where it is difficult for us to support returns:</p>
							<ol>
								<li>Return request is made outside the specified time frame i.e. 3 Business Days after receiving the order.</li>
								<li>Product is damaged because of use or Product is not in the same condition as you received it</li>
								<li>Products with tampered or missing serial numbers</li>
								<li>Items are returned without original packaging</li>
							</ol>
							<h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Cancellation and Refund Process for Prepaid Orders:</h3>
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">To cancel your order and initiate a hassle-free refund, follow these simple steps:</p>
							<ol>
								<li><b>Sign in to your MeriPustak account:</b> Access your account on www.meripustak.com and navigate to the 'My Orders' page.</li>
<li><b>Select Cancellation Option:</b> Choose the cancellation option for the specific order you wish to cancel. Provide the necessary details required for the cancellation process.</li>
<li><b>Confirmation and Processing:</b> Once your cancellation request is submitted, we will promptly process it within a maximum of 24 business hours. An email/SMS notification will be sent to you, confirming the successful cancellation.</li>
<li><b>Refund Initiation:</b> After the cancellation is confirmed, we will initiate the refund process for your entire order amount. The refund will be credited back to your original payment mode, such as credit card, debit card, net banking, UPI, Paytm, PhonePe, e-cash, including other legal electronic payment mode.</li>
<li><b>Refund Timeframe:</b> Rest assured, your refund will be processed swiftly. You can expect to receive the refunded amount within the next 1 to 7 business days.</li>
							</ol>
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">At MeriPustak, we value your satisfaction, and our efficient cancellation and refund process ensure a seamless experience. Should you have any queries or require assistance, our dedicated customer support team is always available to assist you promptly.</p>
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">(Note: This cancellation and refund policy is applicable only for orders cancelled before the product has been shipped.)</p>
							<h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Cancellation Without Prior Notice:</h3>
							<p className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Please be aware that your orders could be cancelled without prior notice, and you will be notified via email or phone regarding the cancellation. This may occur due to the following reasons:</p>
							<ol>
								<li>Unauthorized or fraudulent use of E-Cash</li>
								<li>Suspicion of hacker involvement in the order</li>
								<li>Receipt of books in poor condition</li>
								<li>Unavailability of books from publishers/distributors after order placement</li>
								<li>Impact of a natural disaster affecting both the buyer and seller</li>
								<li>Occurrence of communal violence or riots involving the buyer and seller.</li>
							</ol>
							<h3 className="mt-3 mt-md-0 wow fadeInUp" data-wow-delay=".5s">Payment Modes of Refund Available After Returns/Cancellations:</h3>
							<ol>
								<li><b>Automatic Refunds:</b> Refunds will be credited to the payment mode/account that was originally used for the transaction.</li>
								<li><b>Refund Currency:</b> For orders placed within India, the refund shall be made in Indian Rupees. For international orders, the refund will be processed in USD $, Euro €, and GBP (£), depending on the original payment currency.</li>
								<li><b>Processing Time:</b> Please allow 1 to 7 business days for the refund to be processed after the return/cancellation request has been approved.</li>
								<li><b>Refund Discretion:</b> Refunding on the return item will be handled at our sole and absolute discretion."</li>
							</ol>
                        </div>
                    </div>
                </div>			
            </div>
        </div>
    </section>

    </>);

}

export default ReturnPolicy;